const constants = {
    DELETE_DEMO_DATA_CONFIRMATION:
        'Are you sure you want to delete all the demo data? Demo data includes customer, vehicles, suppliers',
    DEMO_DATA_REMINDER: 'Delete Demo Data',
};

export default constants;
